import { blocksBackOfficeRoles } from '@aw/prypco/constants';
import { JobTitle } from '@aw/prypco/enums';

export const canViewRewards = (
  jobTitle?: JobTitle,
  isInvestor?: boolean,
): boolean => !!(jobTitle === JobTitle.Member && isInvestor);

export const isBlocksBackOfficeUser = (jobTitle?: JobTitle): boolean =>
  jobTitle ? blocksBackOfficeRoles.includes(jobTitle) : false;

export const canViewBlocksBackOffice = (jobTitle?: JobTitle): boolean =>
  isBlocksBackOfficeUser(jobTitle);

export const canViewBackOffice = (jobTitle?: JobTitle): boolean =>
  jobTitle ? canViewBlocksBackOffice(jobTitle) : false;
